export const postflightQuestions = {
  initial: [
    {
      id: 'risk_accuracy',
      text: "How accurate were the risk assessments provided before your flight?",
      prefix: "Risk Assessment:",
      options: [
        { text: "Very Accurate", value: "very_accurate" },
        { text: "Somewhat Accurate", value: "somewhat_accurate" },
        { text: "Not Accurate", value: "not_accurate" }
      ],
      followUp: {
        condition: "not_accurate",
        questions: [
          {
            id: 'missed_risks',
            text: "What risks were missed or incorrectly assessed?",
            type: 'text',
          }
        ]
      }
    },
    {
      id: 'encountered_risks',
      text: "Did you encounter any risks that weren't discussed?",
      prefix: "Unexpected Risks:",
      options: [
        { text: "Yes", value: "yes" },
        { text: "No", value: "no" }
      ],
      followUp: {
        condition: "yes",
        questions: [
          {
            id: 'new_risks',
            text: "What unexpected risks did you encounter?",
            type: 'text',
          }
        ]
      }
    },
    {
      id: 'ai_helpfulness',
      text: "How helpful was the AI assistant in your flight planning?",
      prefix: "AI Assistance:",
      options: [
        { text: "Very Helpful", value: "very_helpful" },
        { text: "Somewhat Helpful", value: "somewhat_helpful" },
        { text: "Not Helpful", value: "not_helpful" }
      ]
    },
    {
      id: 'feedback',
      text: "Do you have any additional feedback about the service?",
      type: 'text',
    }
  ]
}; 